import React, { useState, useEffect } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Card, CardBody } from "@windmill/react-ui";
import Title from "components/form/Title";
import LabelArea from "components/form/LabelArea";
import InputArea from "components/form/InputArea";
import Error from "components/form/Error";
import DrawerButton from "components/form/DrawerButton";
import useTollSubmit from "hooks/useTollSubmit";
import SelectCityWithState from "components/form/SelectCityWithState";
import InputAreaToll from "components/form/InputAreaToll";
import TextAreaCom from "components/form/TextAreaCom";

const TollDrawer = ({ id }) => {
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    loading,
    errors,
    setValue,
  } = useTollSubmit(
    id,
    selectedState,
    setSelectedState,
    selectedCity,
    setSelectedCity
  );

  // const [selectedState, setSelectedState] = useState(null);
  // const [selectedCity, setSelectedCity] = useState(null);

  useEffect(() => {
    if (selectedState?.value) {
      // Register value with your form handler
      // Example if using react-hook-form
      trigger("id_state", selectedState.value);
    }
    if (selectedCity?.value) {
      trigger("id_city", selectedCity.value);
    }
  }, [selectedState, selectedCity]);

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title register={register} title="Edit Toll" />
        ) : (
          <Title register={register} title="Add New Toll" />
        )}
      </div>

      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <Card
          className="flex-grow scrollbar-hide w-full max-h-full"
          style={{ overflow: "visible" }}
        >
          <CardBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="px-2 flex-grow scrollbar-hide w-full max-h-full pb-20">
                <div className="grid grid-cols-12 gap-y-6 gap-x-5 mb-6 items-center">
                  <div className="col-span-12">
                    <SelectCityWithState
                      selectedState={selectedState}
                      setSelectedState={setSelectedState}
                      selectedCity={selectedCity}
                      setSelectedCity={setSelectedCity}
                      errors={errors}
                    />
                  </div>

                  <div className="col-span-12">
                    <LabelArea required label="Toll Name" />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      name="toll_name"
                      label="Toll Name"
                      type="text"
                      placeholder="Eg: Krishnagiri Toll"  
                    />
                    <Error errorName={errors.toll_name} />
                  </div>
                  <div className="col-span-6">
                    <LabelArea required label="Latitude" />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      name="latitude"
                      label="Latitude"
                      type="text"
                      placeholder="Eg: 12.9574"
                      pattern={
                     /^[0-9.-]+$/
                      }
                    />
                    <Error errorName={errors.latitude} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label="Longitude" />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      name="longitude"
                      label="Longitude"
                      type="text"
                      placeholder="Eg: 77.7019"
                      pattern={
                     /^[0-9.-]+$/

                      }
                    />
                    <Error errorName={errors.longitude} />
                  </div>

                  <div className="col-span-12">
                    <LabelArea required label="Sedan" />

                    <div className="grid grid-cols-2 gap-4 border rounded-md p-4 bg-gray-50">
                      
                      <div>
                        <LabelArea required label="Tag Price" />
                        <InputAreaToll
                          trigger={trigger}
                          register={register}
                          name="sedan_tag_price"
                          label="Tag Price"
                          type="text"
                          placeholder="Eg: 100"
                          pattern={/^\d+(\.\d{1,2})?$/}
                          onChange={(e) => {
                            const tagValue = parseFloat(e.target.value) || 0;
                            const doubled = tagValue * 2;

                            setValue("sedan_cash_price", doubled);
                            trigger("sedan_cash_price");
                          }}
                        />
                        <Error errorName={errors.sedan_tag_price} />
                      </div>

                      <div>
                        <LabelArea required label="Cash Price" />
                        <InputAreaToll
                          trigger={trigger}
                          register={register}
                          name="sedan_cash_price"
                          label="Cash Price"
                          type="text"
                          placeholder="Eg: 200"
                          pattern={/^\d+(\.\d{1,2})?$/}
                        />
                        <Error errorName={errors.sedan_cash_price} />
                      </div>
                    </div>
                  </div>

                  <div className="col-span-12">
                    <LabelArea required label="Suv" />

                    <div className="grid grid-cols-2 gap-4 border rounded-md p-4 bg-gray-50">
                      <div>
                        <LabelArea required label="Tag Price" />
                        <InputAreaToll
                          trigger={trigger}
                          register={register}
                          name="suv_tag_price"
                          label="Tag Price"
                          type="text"
                          placeholder="Eg: 100"
                          pattern={/^\d+(\.\d{1,2})?$/}
                          onChange={(e) => {
                            const tagValue = parseFloat(e.target.value) || 0;
                            const doubled = tagValue * 2;

                            setValue("suv_cash_price", doubled);
                            trigger("suv_cash_price");
                          }}
                        />
                        <Error errorName={errors.suv_tag_price} />
                      </div>

                      <div>
                        <LabelArea required label="Cash Price" />
                        <InputAreaToll
                          trigger={trigger}
                          register={register}
                          name="suv_cash_price"
                          label="Cash Price"
                          type="text"
                          placeholder="Eg: 200"
                          pattern={/^\d+(\.\d{1,2})?$/}
                        />
                        <Error errorName={errors.suv_cash_price} />
                      </div>
                    </div>
                  </div>

                  <div className="col-span-12">
                    <LabelArea required label="Tempo Traveller" />

                    <div className="grid grid-cols-2 gap-4 border rounded-md p-4 bg-gray-50">
                      <div>
                        <LabelArea required label="Tag Price" />
                        <InputAreaToll
                          trigger={trigger}
                          register={register}
                          name="tempo_tag_price"
                          label="Tag Price"
                          type="text"
                          placeholder="Eg: 100"
                          pattern={/^\d+(\.\d{1,2})?$/}
                          onChange={(e) => {
                            const tagValue = parseFloat(e.target.value) || 0;
                            const doubled = tagValue * 2;

                            setValue("tempo_cash_price", doubled);
                            trigger("tempo_cash_price");
                          }}
                        />
                        <Error errorName={errors.tempo_tag_price} />
                      </div>

                      <div>
                        <LabelArea required label="Cash Price" />
                        <InputAreaToll
                          trigger={trigger}
                          register={register}
                          name="tempo_cash_price"
                          label="Cash Price"
                          type="text"
                          placeholder="Eg: 200"
                          pattern={/^\d+(\.\d{1,2})?$/}
                        />
                        <Error errorName={errors.tempo_cash_price} />
                      </div>
                    </div>
                  </div>
                    <div className="col-span-12">
  <LabelArea label="Remarks(optional)"  />
 <TextAreaCom
  register={register}
  label="remark"
  name="remark"
  placeholder="Enter toll remark"
  required={false} // explicitly optional
/>

  <Error errorName={errors.remark} />
</div>
                </div>
              </div>

              <DrawerButton id={id} isSubmitting={loading} />
            </form>
          </CardBody>
        </Card>
      </Scrollbars>
    </>
  );
};

export default TollDrawer;
